import React from 'react'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'
import Img from 'gatsby-image'

export default class AppDetails extends React.Component{
    render(){
	var imgs = this.props.imgs;
	var app_links = [
	    {
		url: 'https://app.sharemeals.org/',
		img: imgs.badge.browser,
	    },
	    {
		url: 'https://itunes.apple.com/app/id1227449725',
		img: imgs.badge.ios,
	    },
	    {
		url: 'https://play.google.com/store/apps/details?id=org.sharemeals.app',
		img: imgs.badge.google,
	    },
	];
	return(
	    <div className="section dark">
		<Grid>
		    <Row style={{alignItems: 'center'}}>
			<Col xs={10} xsOffset={1} md={6} mdOffset={0} xl={5} xlOffset={1}>
			    <h2 className="title">
				The Share Meals App
			    </h2>
			    <p>
				Share Meals is a digital platform where students can share extra meal swipes and post extra food from club events with students who are food insecure. It works in real time, based on your location. You can find extra food within a 5 minute walking distance with one quick glance.
			    </p>
			    <Row style={{marginTop: '2rem'}}>
				{app_links.map((link, index) => {
				     return(
					 <Col key={index}
					      xs={4}>
					     <a href={link.url} target='_new'>
						 <Img
						     sizes={link.img.childImageSharp.sizes} />
					     </a>
					 </Col>
				     )
				})
				}
			    </Row>
			</Col>
			<Col xs={0} md={6} lg={5} lgOffset={1} xl={4}>
			    <br className="hidden-md hidden-lg hidden-xl" />
			    <Img sizes={imgs.phone.childImageSharp.sizes} />
			</Col>
		    </Row>
		</Grid>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/app-details/index.jsx